import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { EditTypes } from "./EditTypes";



export class ColumnCopyIcon extends ColumnBase {

    public getContent(row: any): HTMLElement {
        return <i className="fal fa-copy"></i>;
    }

    public createCell(rowModel: any, idField: string): HTMLElement {
        const cell = super.createCell(rowModel, idField);
        cell.classList.add("mt-copy-icon");
        cell.classList.add("pointer");
        cell.setAttribute("data-id", rowModel[idField]);
        cell.addEventListener("click", this.onCopyIconClicked);
        return cell;
    }
    onCopyIconClicked = (ev: MouseEvent) => {
        if (this.table.props.onCopyIconClicked) {
            this.table.props.onCopyIconClicked((ev.currentTarget as HTMLElement).getAttribute("data-id"));
            ev.stopPropagation();
        }
    }

}